<template>
  <div class="nav">
    <div class="menu1-bar">
      <ul>
        <li
          class="list-item"
          v-on:click="goTo('data')"
          :class="{ active: activeSection == 'data' }"
        >
          <a>Daten</a>
        </li>
        <li
          class="list-item"
          v-on:click="goTo('flows', 'process-list')"
          :class="{ active: activeSection == 'flows' }"
        >
          <a>Prozesse</a>
        </li>
      </ul>
    </div>
    <div class="logo-wrapper">
      <div class="logo">
        <img src="../assets/logo.svg" />
      </div>
      <div class="title">&nbsp;Codelos.io</div>
    </div>
    <div class="menu2-bar">
      <ul v-if="activeSection == 'data'">
        <!--TODO: Delete v-show if we want to display APP tab -->
        <li
          v-for="page in customUserNavItems.slice(0, 5)"
          :key="page.name"
          class="list-item"
          :class="{ active: page.name == activeDatabase.name }"
        >
          <a @click="goTo(activeSection, page.name)">{{
            nameWithoutPrefix(page.name)
          }}</a>
          <i
            v-if="userHasTableEditPermission(page.access_level)"
            @click="shareDatabase(page.name)"
            class="fas fa-share"
            v-b-tooltip.hover.top
            title="Teilen"
          ></i>
          <i
            v-if="userHasTableEditPermission(page.access_level)"
            @click="removeDatabase(page.name)"
            class="fa fa-trash"
            v-b-tooltip.hover.top
            title="Löschen"
          ></i>
          <i
            v-if="
              userHasTableEditPermission(page.access_level) &&
              page.count == 0 &&
              isAdmin
            "
            @click="editDatabase(page.name)"
            class="fa fa-edit"
            v-b-tooltip.hover.top
            title="Editieren"
          ></i>
          <i
            v-if="page.access_level != 'owner'"
            @click="leaveDatabase(page.name)"
            class="fas fa-sign-out-alt"
            v-b-tooltip.hover.top
            title="Verlassen"
          ></i>
        </li>
        <li class="list-item" v-click-outside="hideList">
          <a class="more" @click="showList"></a>
          <div class="toggle-list-wrapper" v-show="showMore">
            <div class="item more" @click="hideList"></div>
            <div
              v-for="page in customUserNavItems.slice(5)"
              :key="page.name"
              class="item"
              @click="goTo(activeSection, page.name)"
            >
              <a>{{ nameWithoutPrefix(page.name) }}</a>
            </div>
            <div
              class="item last-item"
              @click="toggleNewDataType()"
              v-if="hasCustomAddNewPermission"
            >
              <i class="far fa-plus-square"></i>&nbsp;&nbsp; Weiterer Inhalt
              erstellen
            </div>
          </div>
        </li>
      </ul>
      <div class="sign-out-wrapper">
        <a class="sign-out">
          <amplify-sign-out v-if="user"></amplify-sign-out>
        </a>
      </div>
    </div>
  </div>
</template>

<script>
import store from '../store/store';

export default {
  name: 'Navbar',
  data() {
    return {
      showMore: false,
      showNewDataType: false,
      isConfirmationModalVisible: false,
      hasCustomAddNewPermission: false,
    };
  },
  props: {
    customUserNavItems: Array,
    activeDatabase: Object,
  },
  methods: {
    toggleList: function () {
      this.showMore = !this.showMore;
    },
    showList: function () {
      this.showMore = true;
    },
    hideList: function () {
      this.showMore = false;
    },
    getTitle: function () {
      if (this.$route.params.title) return this.$route.params.title;
      else return this.appSettings('title');
    },
    shareDatabase: async function (dataBase) {
      if (this.activeDatabase.name != dataBase)
        await this.goTo('data', dataBase);
      this.$emit('toggleShareDatabase', dataBase);
    },
    removeDatabase: async function (dataBase) {
      if (this.activeDatabase.name != dataBase)
        await this.goTo('data', dataBase);
      this.$emit('toggleRemoveDatabase', dataBase);
    },
    leaveDatabase: async function (dataBase) {
      if (this.activeDatabase.name != dataBase)
        await this.goTo('data', dataBase);
      this.$emit('toggleLeaveDatabase', dataBase);
    },
    editDatabase: async function (dataBase) {
      if (this.activeDatabase.name != dataBase)
        await this.goTo('data', dataBase);
      this.$emit('toggleEditDatabaseSchema', dataBase);
    },
    goTo: async function (section, database = null, processId) {
      let prop = database ? 'database' : 'processId';
      let val = database ? database : processId;

      let rslt = await this.$router.push({
        path: '/',
        query: { section: section, [prop]: val },
      });
      return rslt;
    },
    getUserCustomDatabases: function () {
      var url = process.env.VUE_APP_DATA_API;
      url += '/user-tables';

      // API headers
      var myHeaders = new Headers();
      myHeaders.append(
        'Authorization',
        'Bearer ' + this.user.signInUserSession.accessToken.jwtToken
      );

      return fetch(url, {
        headers: myHeaders,
        method: 'GET',
      })
        .then((response) => {
          return response.json();
        })
        .then((json) => {
          this.customUserNavItems = json;
        });
    },
    toggleNewDataType: function () {
      this.$emit('toggleNewDataType');
    },
    nameWithoutPrefix: function (name) {
      return name.split('_').slice(1).join('_');
    },
    userHasTableEditPermission: function (accessLevel) {
      let editPermissions = ['full_access', 'owner'];
      if (editPermissions.includes(accessLevel)) return true;
      else return false;
    },
    fetchUserAccessLevel: function () {
      var url = process.env.VUE_APP_DATA_API;
      url += '/users/' + this.user.username;
      url += '/policies?resource=databases';

      let myHeaders = new Headers();
      myHeaders.append(
        'Authorization',
        'Bearer ' + this.user.signInUserSession.accessToken.jwtToken
      );

      fetch(url, {
        headers: myHeaders,
        method: 'GET',
      })
        .then((response) => {
          return response.json();
        })
        .then((json) => {
          if (
            json.policies.length > 0 &&
            json.policies[0].access_level == 'edit'
          )
            this.hasCustomAddNewPermission = true;
          else this.hasCustomAddNewPermission = false;
        });
    },
  },
  created() {
    this.fetchUserAccessLevel();
  },
  computed: {
    user() {
      return store.state.user;
    },
    isAdmin() {
      return store.state.isAdmin;
    },
    activePage() {
      return this.$route.query.database;
    },
    activeSection() {
      return this.$route.query.section;
    },
  },
  directives: {
    clickOutside: {
      bind: function (el, binding, vnode) {
        el.eventSetDrag = function () {
          el.setAttribute('data-dragging', 'yes');
        };
        el.eventClearDrag = function () {
          el.removeAttribute('data-dragging');
        };
        el.eventOnClick = function (event) {
          var dragging = el.getAttribute('data-dragging');
          // Check that the click was outside the el and its children, and wasn't a drag
          if (!(el == event.target || el.contains(event.target)) && !dragging) {
            // call method provided in attribute value
            vnode.context[binding.expression](event);
          }
        };
        document.addEventListener('touchstart', el.eventClearDrag);
        document.addEventListener('touchmove', el.eventSetDrag);
        document.addEventListener('click', el.eventOnClick);
        document.addEventListener('touchend', el.eventOnClick);
      },
      unbind: function (el) {
        document.removeEventListener('touchstart', el.eventClearDrag);
        document.removeEventListener('touchmove', el.eventSetDrag);
        document.removeEventListener('click', el.eventOnClick);
        document.removeEventListener('touchend', el.eventOnClick);
        el.removeAttribute('data-dragging');
      },
    },
  },
};
</script>

<style>
*,
*::before,
*::after {
  -webkit-box-sizing: unset;
}

@import 'https://use.fontawesome.com/releases/v5.6.3/css/all.css';
@import 'https://fonts.googleapis.com/css?family=Hammersmith+One|Nunito|Orbitron:500|Poiret+One';

.nav {
  background-color: #1f2532;
  color: #f3f7ea;
  width: 100%;
  height: fit-content;
  padding-bottom: 0;
}
.menu1-bar {
  text-transform: uppercase;
  font-size: 10px;
  padding: 0;
  display: flex;
  align-items: center;
}
.nav .menu1-bar .list-item.active {
  font-weight: 500;
  color: #fff;
}
.menu1-bar a::selection {
  background: transparent;
}

.menu2-bar a::selection {
  background: transparent;
}
.menu2-bar a::selection {
  background: transparent;
}

.logo-wrapper {
  width: 100%;
  height: 33px;
  padding-bottom: 36px;
  -webkit-box-sizing: unset;
  box-sizing: unset;
}
.nav .logo {
  float: left;
  font-size: 19px;
  text-rendering: optimizelegibility;
  -webkit-font-smoothing: antialiased;
  line-height: 22px;
  text-align: left;
  margin: 0px;
  margin-top: -15px;
}

.logo img {
  width: 55px;
}

.title {
  float: left;
  margin: 0 20px 0 0;
  font-size: 33px;
  padding-right: 23px;
  line-height: 33px;
  text-rendering: optimizelegibility;
  -webkit-font-smoothing: antialiased;
  font-family: 'Nunito', sans-serif;
  color: white;
}

.nav ul li {
  list-style: none;
  display: inline;
  font-family: 'Open Sans', open-sans, sans-serif;
  -webkit-font-smoothing: antialiased;
  color: #9aa4b3;
  cursor: pointer;
}

.nav ul {
  padding: 0;
  margin: 0;
  margin-left: 75px;
  height: 33px;
  padding-top: 15px;
}

.nav ul li a {
  text-decoration: none;
  display: block;
  height: 31px;
}

.nav ul li a.active {
  padding: 0;
  margin: 0;
  margin-left: 75px;
  display: block;
  height: 29px;
}

.nav ul li a:hover {
  color: #ffff;
}

.nav ul li a:visited {
  color: #9aa4b3;
  text-decoration: none;
}

.nav .list-item {
  margin: 0 45px 0 0;
  display: inline-block;
  cursor: pointer;
}

.nav .list-item a {
  display: inline;
}

.nav .list-item i {
  margin-left: 10px;
  visibility: hidden;
}

.nav .list-item:hover i {
  visibility: visible;
}

.nav .menu2-bar .list-item {
  margin: 0 75px 0 0;
  vertical-align: top;
}

.nav .menu2-bar .list-item.active {
  margin: 0 75px 0 0;
  border-bottom: solid 3px rgb(255, 51, 102);
  padding-bottom: 16px;
  color: #ffff;
}

.nav .Button__button___1FrBC {
  float: right;
  background: none;
  border: none;
  text-transform: none;
  color: #9aa4b3;
  display: inline;
  font-family: 'Open Sans', open-sans, sans-serif;
  -webkit-font-smoothing: antialiased;
  font-size: 16px;
  color: #9aa4b3;
  cursor: pointer;
  padding: none;
}

.nav ul li a.more {
  background-image: url('../assets/img/tree-dots.png');
  display: inline-block;
  width: 30px;
  height: 22px;
  background-size: 368px 13px;
  background-repeat: no-repeat;
  background-position: -4px 4px;
  cursor: pointer;
}

.toggle-list-wrapper .item.more {
  background-image: url('../assets/img/tree-dots.png');
  width: 30px;
  background-size: 368px 13px;
  background-repeat: no-repeat;
  background-position: 18px -2px;
  cursor: pointer;
}

.toggle-list-wrapper .item.more:hover {
  background-color: #fff;
}

.nav ul li a.more:hover {
  background-position: -62px 3px;
}
/* a.sign-out {
  position: relative;
  right: 0;
  top: 0;
} */
.toggle-list-wrapper {
  background-color: #ffff;
  position: relative;
  left: -53px;
  top: 36px;
  -webkit-box-shadow: var(--elevation-high);
  box-shadow: var(--elevation-high);
  max-width: 600px;
  overflow: scroll;
  z-index: 2;
  border-radius: 3px;
  display: inline-block;
  clear: both;
  padding: 17px 0 17px 0;
  width: 226px;
  margin-top: 127px;
  margin-top: -47px;
}

.toggle-list-wrapper .item {
  cursor: pointer;
  padding: 9px 23px;
  text-align: left;
  height: fit-content;
  margin: 0;
  font-weight: 300;
  color: #464d5d;
  font-size: 11px;
}
.toggle-list-wrapper .item.last-item {
  border-top: solid 1px #e1e4ea;
}

.toggle-list-wrapper .item:hover {
  background-color: #f0f0f0;
}
.nav-top .Button__button___1FrBC {
  float: none;
  margin: 0;
  width: auto;
  padding: 0;
  opacity: 1;
  line-height: normal;
  text-align: left;
}

ul.right-menu {
  margin: 0;
  padding: 0;
  display: block;
  text-align: left;
  position: relative;
  right: 0;
  top: 0;
  height: auto;
}

.Form__formField___2DWhT {
  margin: 0;
}

ul.right-menu li {
  display: block;
  text-align: right;
}

ul.right-menu li span {
  display: block;
  font-size: 14px;
  letter-spacing: 1.1px;
}

.Input__inputLabel___nQolz {
  margin-bottom: 0;
}
ul.right-menu .sign-out {
  width: auto;
  height: auto;
}
</style>
